import React, { useEffect, useState, useRef } from "react";
import "./Community.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { HiOutlineHashtag } from "react-icons/hi";
import { useSelector } from "react-redux";
import { LuMessageSquareReply } from "react-icons/lu";
import { IoSend } from "react-icons/io5";
import {
  getComunityTopicList,
  getTopicCommunityById,
  createPost,
  updatePost,
  getCommentsByPost,
  ProviderDisabled,
  PatientDisabled,
} from "../services/providerService";
import { toast } from "react-toastify";
import { apiUrl, PORT } from "../../environment";
import { FaRegThumbsUp } from "react-icons/fa";
function CommunityComponent() {
  const { data } = useSelector((state) => state.login);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [messageText, setMessageText] = useState("");
  const [replyText, setReplyText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("Provider-Forum");
  const [topic, setTopic] = useState([]);
  const [community, setComunity] = useState(null);
  const [communityChatData, setCommunityChatData] = useState([]);
  // ********************pagination state for topic ****************************************************
  const [totalItemsTopic, setTotalItemsTopic] = useState(0);
  const [totalPagesTopic, setTotalPagesTopic] = useState(0);
  const [limitTopic, setLimitTopic] = useState(10);
  const [pageTopic, setPageTopic] = useState(0);
  const [totalItemsComments, setTotalItemsComments] = useState(0);
  const [totalPagesComments, setTotalPagesComments] = useState(0);
  const [limitComments, setLimitComments] = useState(10);
  const [pageComments, setPageComments] = useState(1);
  const chatContainerRef = useRef(null);
  const chatCommentsContainerRef = useRef(null);

  const [isFetchingOld, setIsFetchingOld] = useState(false);
  // const prevMessagesLength = useRef(communityChatData?.length || 0);

  const _getForumTopicList = async (eventKey = "", searchText = "") => {
    try {
      const response = await getComunityTopicList({
        page: pageTopic + 1,
        limitTopic,
        searchKey: searchText,
        category: eventKey,
      });

      setTopic(response.data?.items || []);
      setComunity(response.data?.items[0]);
      setTotalPagesTopic(response.data?.totalPages || 0);
      setTotalItemsTopic(response.data?.totalItems || 0);
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  useEffect(() => {
    _getForumTopicList(selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    if (community) {
      setCommunityChatData([]);
      setPage((prevPage) => {
        return 0;
      });
      _getTopicsCommunity();
    }
  }, [community, selectedCategory]);

  const _getTopicsCommunity = async () => {
    try {
      const response = await getTopicCommunityById(
        {
          page: page + 1,
          limit,
          searchKey: "",
          topic_id: community._id,
          category: community.category,
        },
        selectedCategory
      );

      const newPosts = response.data?.items || [];

      // Update the community chat data by checking for duplicates
      setCommunityChatData((prevData) => {
        // Filter out any duplicate posts that are already in the previous data
        const uniquePosts = newPosts.filter(
          (post) =>
            !prevData.some((existingPost) => existingPost._id === post._id)
        );
        return [...uniquePosts.reverse(), ...prevData];
      });

      setTotalPages(response.data?.totalPages || 0);
      setTotalItems(response.data?.totalItems || 0);
      setPage((prevPage) => {
        return prevPage + 1;
      });
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  const uplodPost = async () => {
    if (messageText.length <= 0) {
      toast.info("Please enter the message");
      return;
    }
    const postMessage = {
      title: "",
      content: messageText,
      author: data?._id,
      topic_id: community?._id,
      tags: [],
      comments: [],
      upvotes: [],
      downvotes: [],
    };
    try {
      const response = await createPost(
        postMessage,
        community,
        selectedCategory
      );
      setCommunityChatData((prevData) => [...prevData, response.data]);
      setMessageText("");
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  const addLike = async (item) => {
    try {
      const response = await updatePost(
        item,
        { upvotes: data._id },
        selectedCategory
      );

      // Update the specific post in the state without re-fetching the entire list
      setCommunityChatData((prevData) =>
        prevData.map((post) =>
          post._id === item._id
            ? {
              ...post,
              upvotes: post.upvotes.includes(data._id)
                ? post.upvotes.filter((id) => id !== data._id)
                : [...post.upvotes, data._id],
            } // Add user to upvotes
            : post
        )
      );
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  const handleCommunityClick = (item) => {
    setComunity(item);
    setPage((prevPage) => {
      return 0;
    });
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.trim();
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      _getForumTopicList(selectedCategory, query);
    }
  };

  const handleCategory = (eventKey) => {
    setSelectedCategory(eventKey);
    _getForumTopicList(eventKey);
  };

  //  ****************************************************on scroll chat loade logic *****************************************************************

  const prevMessagesLength = useRef(0);
  const prevScrollHeight = useRef(0);

  const handleScroll = () => {
    const container = chatContainerRef.current;
    if (!container) return;

    const { scrollTop } = container;

    // Fetch older messages when scroll reaches top
    if (scrollTop === 0 && page <= totalPages && !isFetchingOld) {
      setIsFetchingOld(true);
      prevScrollHeight.current = container.scrollHeight;
      _getTopicsCommunity(); // Fetch older messages
    }
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const currentMessagesLength = communityChatData.length;

    // Restore scroll position if older messages were fetched
    if (isFetchingOld) {
      requestAnimationFrame(() => {
        const newScrollHeight = container.scrollHeight;
        const scrollDifference = newScrollHeight - prevScrollHeight.current;

        container.scrollTop = scrollDifference;
        setIsFetchingOld(false);
      });
    } else {
      // Scroll to bottom when a new message is added (send message case)
      container.scrollTop = container.scrollHeight;
    }

    // Update previous messages length
    prevMessagesLength.current = currentMessagesLength;
  }, [communityChatData]);

  const handleCommentsScroll = async (post) => {
    const { scrollTop, scrollHeight, clientHeight } =
      chatCommentsContainerRef.current;

    // Detect when user reaches the top of the container
    if (scrollTop === 0 && pageComments < totalPagesComments) {
      setPageComments((prevPage) => {
        const newPage = prevPage + 1;
        return newPage;
      });

      // Call the API to fetch new comments
      await __getCommentsByPost(post._id, pageComments + 1);

      // Optionally scroll to a fixed position to prevent the user from noticing the scroll jump
      if (chatCommentsContainerRef.current) {
        chatCommentsContainerRef.current.scrollTop = 10;
      }
    }

    // Detect when user reaches the bottom of the container
    if (
      scrollHeight - scrollTop === clientHeight &&
      pageComments <= totalPagesComments
    ) {

      // Call the API to load more comments (if you want to load new comments at the bottom as well)
      setPageComments((prevPage) => {
        const newPage = prevPage + 1;
        return newPage;
      });

      await __getCommentsByPost(post._id, pageComments + 1);
    }
  };

  const colors = [
    "#66D4CF", // Mint
    // "#FFD60A", //  Yellow
    "#40C8E0", // Teal
    // "#BF5AF2", // Purple
    "#64D2FF", // Cyan
    "#E9E976", //   light yellow
    // "#5E5CE6", // Indigo
    "#e9c183", // light Orange
  ];


  //**********************************Handle Reply************************************************ */

  const [showReplies, setShowReplies] = useState({});
  const [replies, setReplies] = useState({});

  // Toggle reply visibility
  const handleReplyClick = async (postId) => {
    setShowReplies((prevState) => ({
      ...prevState,
      [postId]: !prevState[postId],
    }));

    // Fetch replies only if they haven't been fetched already
    if (!replies[postId] || replies[postId].length === 0) {
      await __getCommentsByPost(postId);
    }
  };

  const __getCommentsByPost = async (postId, pagevalue = null) => {
    const result = await getCommentsByPost(postId, {
      page: pagevalue ? pagevalue : pageComments,
      limit: limitComments,
    });
    setReplies((prevState) => {
      return {
        ...prevState,
        [postId]: [...(prevState[postId] || []), ...(result.data.data || [])],
      };
    });

    setTotalPagesComments(result?.data?.totalPages || 0);

    setTotalItemsComments(result.data?.totalItems || 0);

    setPageComments(result.data?.currentPage);
  };

  const handleAddReply = async (post, replyText) => {
    const comments = {
      post_id: post._id,
      content: replyText,
      author: data?._id,
    };

    const result = await updatePost(
      post,
      { comments: comments },
      selectedCategory
    );

    setReplies((prevState) => {
      return {
        ...prevState,
        [post._id]: [
          ...([
            {
              comments: result?.data,
              commentAuthor: {
                name: `${data?.firstName} ${data?.lastName}`,
              },
            },
          ] || []),
          ...(prevState[post._id] || []),
        ],
      };
    });

    setReplyText("");
  };

  // *****************************************************************************************

  const handleOptionClick = async (actionType, role, post) => {
    try {
      // Make the API call based on the type
      if (actionType === "post_delete") {
        const deletePost = await updatePost(
          post,
          { isDeleted: true },
          selectedCategory,
          actionType
        );
        setCommunityChatData((prevData) => {

          const updatedData = prevData.filter(
            (item) => item._id !== deletePost?.data._id
          );

          return updatedData;
        });

        // await __getCommentsByPost(post._id);
      } else if (actionType === "user_disabled") {
        if (role === "Provider") {
          await ProviderDisabled({
            userId: post?.authorDetails?._id,
            isBlockedFromCommunity: true,
          });
          setCommunityChatData((prevData) => {
            // Correctly find the item and update it
            const updatedData = prevData.map((item) =>
              item._id === post?._id
                ? {
                  ...item,
                  authorDetails: {
                    ...item.authorDetails,
                    isBlockedFromCommunity:
                      !item?.authorDetails?.isBlockedFromCommunity,
                  },
                }
                : item
            );


            return updatedData;
          });
        } else if (role === "Patient") {
          await PatientDisabled({
            patientId: post?.authorDetails?._id,
            isBlockedFromCommunity: true,
          });
          setCommunityChatData((prevData) => {
            // Correctly find the item and update it
            const updatedData = prevData.map((item) =>
              item._id === post?._id
                ? {
                  ...item,
                  authorDetails: {
                    ...item.authorDetails,
                    isBlockedFromCommunity:
                      !item?.authorDetails?.isBlockedFromCommunity,
                  },
                }
                : item
            );


            return updatedData;
          });
        }
      } else if (actionType === "user_enabled") {
        if (role === "Provider") {
          await ProviderDisabled({
            userId: post?.authorDetails?._id,
            isBlockedFromCommunity: false,
          });

          setCommunityChatData((prevData) => {
            // Correctly find the item and update it
            const updatedData = prevData.map((item) =>
              item._id === post?._id
                ? {
                  ...item,
                  authorDetails: {
                    ...item.authorDetails,
                    isBlockedFromCommunity:
                      !item?.authorDetails?.isBlockedFromCommunity,
                  },
                }
                : item
            );


            return updatedData;
          });
        } else if (role === "Patient") {
          await PatientDisabled({
            patientId: post?.authorDetails?._id,
            isBlockedFromCommunity: false,
          });

          setCommunityChatData((prevData) => {
            // Correctly find the item and update it
            const updatedData = prevData.map((item) =>
              item._id === post?._id
                ? {
                  ...item,
                  authorDetails: {
                    ...item?.authorDetails,
                    isBlockedFromCommunity:
                      !item?.authorDetails?.isBlockedFromCommunity,
                  },
                }
                : item
            );

            return updatedData;
          });
        }
      } else if (actionType === "post_disabled") {
        await updatePost(post, { isDesabled: true }, selectedCategory);

        setCommunityChatData((prevData) => {
          // Correctly find the item and update it
          const updatedData = prevData.map((item) =>
            item._id === post?._id
              ? { ...item, isDesabled: !item.isDesabled }
              : item
          );

          return updatedData;
        });
      } else if (actionType === "post_enabled") {
        await updatePost(post, { isDesabled: false }, selectedCategory);
        setCommunityChatData((prevData) => {
          // Correctly find the item and update it
          const updatedData = prevData.map((item) =>
            item._id === post?._id
              ? { ...item, isDesabled: !item.isDesabled }
              : item
          );
          return updatedData;
        });
      }
    } catch (error) {
    }
  };

  // **********************************************************************************************
  const textareaRef = useRef(null);
  const MAX_ROWS = 5; // Maximum number of rows before scrolling starts
  // Adjust the height based on the content
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      const lineHeight = parseInt(
        window.getComputedStyle(textarea).lineHeight,
        10
      );
      const maxHeight = MAX_ROWS * lineHeight; // Max height for 3 rows
      const scrollHeight = textarea.scrollHeight;

      if (scrollHeight <= maxHeight) {
        textarea.style.height = `${scrollHeight}px`; // Expand to fit content if within max height
      } else {
        textarea.style.height = `${maxHeight}px`; // Set to max height if content exceeds 3 rows
        textarea.style.overflowY = "auto"; // Enable scrolling
      }
    }
  }, [messageText]);

  return (
    <div className="community-workspace">
      {data?.isBlockedFromCommunity && (
        <div className="centered-badge">
          <span className="badge bg-info text-dark text-center">
            You are disabled from admin
          </span>
        </div>
      )}

      <div className="community-chat-block-area d-flex p-0">
        <div className="community-chat-history-area">
          <div className="dropdowns-here d-flex gap-2">
            <span className="community-section-label">Channels</span>
            {data.role == "ADMIN" && (
              <Dropdown
                className="patient-info-dropdown "
                onSelect={handleCategory}
              >
                <Dropdown.Toggle className="db-dropdown h-100">
                  {selectedCategory === ""
                    ? "category"
                    : selectedCategory == "All-Record"
                      ? "All Forum"
                      : selectedCategory}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item eventKey="All-Record">All Forum</Dropdown.Item>
                  <Dropdown.Item eventKey="Provider-Forum">
                    Provider-Forum
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="Patient-Forum">
                    Patient-Forum
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
          <div className="search-area-box d-flex align-items-center">
            <div className="search_area">
              <input
                type="search"
                value={searchText}
                onChange={handleSearchChange}
                placeholder="Search channels"
                className="form-control"
                aria-label="Search community channels"
              />
            </div>
          </div>
          <div
            className="chat-block d-flex flex-column  "
            style={{ overflowY: "auto" }}
          >
            {topic.length > 0 ? (
              topic.map((item, index) => (
                <button
                  type="button"
                  key={item._id || item.name || index}
                  className={`people-info d-flex align-items-start justify-content-between ${community?._id === item._id ? "active" : ""
                    }`}
                  onClick={() => handleCommunityClick(item)}
                  aria-pressed={community?._id === item._id}
                >
                  <div className="profile-person-block d-flex">
                    <div className="profile-pic">
                      <div className="topic-avatar" aria-hidden="true">
                        <span>{item.name?.trim()?.[0]?.toUpperCase() || "#"}</span>
                        {item.image && (
                          <img
                            src={`${apiUrl}${PORT}/user-service/getimages/${item.image}`}
                            alt=""
                            onError={(event) => {
                              event.currentTarget.style.display = "none";
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="person-info">
                      {item.name}
                      <span>{item.description}</span>
                    </div>
                  </div>
                </button>
              ))
            ) : (
              <div className="text-center bold">No topic found</div>
            )}
          </div>
        </div>

        {community && (
          <div className="community-main-chatbox ">
            <div className="community-info d-flex align-items-center justify-content-between">
              <div className="community-channel-heading">
                <p>
                  <HiOutlineHashtag /> {community.name}
                </p>
                {community.description && <span>{community.description}</span>}
              </div>
              <div className="community-info-signs d-flex align-items-center"></div>
            </div>
            <div
              className="community-chat-messages"
              style={{ overflowY: "auto" }}
              ref={chatContainerRef}
              onScroll={handleScroll}
            >
              {communityChatData?.length > 0 ? (
                communityChatData.map((item, index) => (
                  <React.Fragment key={item._id || index}>
                    {item?.authorDetails?._id == data?._id ||
                      item?.author == data?._id ? (
                      <div className="outgoing-texts">
                        <div className="community-my-textmessages d-flex">
                          <div className="profile-pic">
                            <div className="person-pic">
                              <div
                                className="patient-initials"
                                style={{
                                  background: colors[index % colors.length],
                                }}
                              >
                                {`${item?.authorDetails?.firstName?.[0] ||
                                  item?.authorDetails?.ananomousName?.[0] ||
                                  ""
                                  }${item?.authorDetails?.lastName?.[0] ||
                                  (data.role == "admin" ||
                                    data.role == "ADMIN" ||
                                    data.role == "DOCTOR"
                                    ? data?.firstName[0] +
                                    " " +
                                    data?.lastName[0]
                                    : "Admin ") ||
                                  ""
                                  }`.toUpperCase()}
                              </div>
                            </div>
                          </div>
                          <div className="person-info">
                            <p className="d-flex m-0">
                              {item?.authorDetails?.name ||
                                item?.authorDetails?.ananomousName ||
                                (data.role == "admin" ||
                                  data.role == "ADMIN" ||
                                  data.role == "DOCTOR"
                                  ? data?.firstName + " " + data?.lastName
                                  : "Admin ") ||
                                ""}{" "}
                              (me){" "}
                              {item?.isDesabled && (
                                <div
                                  class=" p-0 p-1  rounded-lg color-danger"
                                  style={{
                                    fontSize: "10px",
                                    height: "10px",
                                    color: "red",
                                  }}
                                >
                                  {" "}
                                  Post disabled
                                </div>
                              )}{" "}
                              {item?.authorDetails?.isBlockedFromCommunity && (
                                <div
                                  class=" p-0 p-1  rounded-lg color-danger"
                                  style={{
                                    fontSize: "10px",
                                    height: "10px",
                                    color: "red",
                                  }}
                                >
                                  {" "}
                                  User Block
                                </div>
                              )}
                              <pre className="mx-2">
                                {item?.created_at || item?.createdAt
                                  ? new Date(
                                    item?.created_at || item?.createdAt
                                  ).toLocaleDateString("en-US") ===
                                    new Date().toLocaleDateString("en-US")
                                    ? "Today " +
                                    new Date(
                                      item?.created_at || item?.createdAt
                                    ).toLocaleString("en-US", {
                                      hour12: true,
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                    : new Date(
                                      item?.created_at || item?.createdAt
                                    ).toLocaleString("en-US", {
                                      hour12: true,
                                      year: "numeric",
                                      month: "numeric",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "No date"}
                              </pre>
                              <div className="community-info-signs d-flex align-items-center text-right justify-right">
                                <Dropdown align="end" className="ms-1">
                                  <Dropdown.Toggle
                                    as="div"
                                    id="dropdown-custom-components"
                                    className="three-dots"
                                  >
                                    {(data._id == item?.authorDetails?._id ||
                                      data._id == item?.author ||
                                      data.role == "ADMIN") && (
                                        <BsThreeDotsVertical size={24} />
                                      )}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    {(data._id == item?.authorDetails?._id ||
                                      data._id == item?.author) && (
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleOptionClick(
                                              "post_delete",
                                              null,
                                              item
                                            )
                                          }
                                        >
                                          Post Delete
                                        </Dropdown.Item>
                                      )}

                                    {(data.role == "ADMIN" ||
                                      data.role == "admin") && (
                                        <>
                                          {" "}
                                          {item.isDesabled ? (
                                            <Dropdown.Item
                                              onClick={() =>
                                                handleOptionClick(
                                                  "post_enabled",
                                                  null,
                                                  item
                                                )
                                              }
                                            >
                                              Post Enabled
                                            </Dropdown.Item>
                                          ) : (
                                            <Dropdown.Item
                                              onClick={() =>
                                                handleOptionClick(
                                                  "post_disabled",
                                                  null,
                                                  item
                                                )
                                              }
                                            >
                                              Post Disabled
                                            </Dropdown.Item>
                                          )}
                                          {item?.authorDetails?.role ==
                                            "DOCTOR" ||
                                            item?.authorDetails?.role ==
                                            "PROVIDER" ? (
                                            <Dropdown.Item
                                              onClick={() =>
                                                handleOptionClick(
                                                  "user_disabled",
                                                  "Provider",
                                                  item
                                                )
                                              }
                                            >
                                              Provider Disabled
                                            </Dropdown.Item>
                                          ) : (
                                            <> </>
                                          )}
                                        </>
                                      )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </p>
                            <div className="msg-emoji">
                              <span>{item.content}</span>
                              <div className="emoji d-flex gap-1">
                                <div
                                  onClick={() => addLike(item)}
                                  className={
                                    item.upvotes.includes(data._id)
                                      ? "reacted-emojis liked"
                                      : "reacted-emojis"
                                  }
                                  style={{
                                    color:
                                      item.upvotes.includes(data._id) &&
                                      "green",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FaRegThumbsUp />
                                  {item?.upvotes?.length}
                                </div>
                                {!data.isBlockedFromCommunity && (
                                  <div className="add-emoji">
                                    <LuMessageSquareReply
                                      onClick={() => handleReplyClick(item._id)}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Show Replies UI */}
                            {showReplies[item._id] && (
                              <div className="replies-section">
                                {/* Input for New Reply */}
                                <div className="reply-input gap-2">
                                  <input
                                    type="text"
                                    value={replyText}
                                    onChange={(e) =>
                                      setReplyText(e.target.value)
                                    }
                                    placeholder="Add your reply..."
                                    className="form-control"
                                  />
                                  <Button
                                    className="filled-btn px-3"
                                    onClick={() =>
                                      handleAddReply(item, replyText)
                                    }
                                  >
                                    <IoSend />
                                  </Button>
                                </div>

                                <div
                                  className="replies-list mt-2 "
                                  ref={chatCommentsContainerRef}
                                  onScroll={() => handleCommentsScroll(item)}
                                >
                                  {replies[item._id]?.length > 0 ? (
                                    replies[item._id]?.map((reply, idx) => (
                                      <div key={idx} className="reply">
                                        <div className="reply-author">
                                          {reply?.commentAuthor.name}{" "}
                                          {new Date(
                                            reply?.comments?.created_at
                                          ).toLocaleTimeString()}
                                        </div>
                                        <div className="reply-content">
                                          {reply?.comments?.content}
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="no-replies">
                                      No replies yet.
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="incoming-texts">
                        <div className="community-delivered-messages d-flex">
                          <div className="profile-pic">
                            <div className="person-pic">
                              <div
                                className="patient-initials"
                                style={{
                                  background: colors[index % colors.length],
                                }}
                              >
                                {`${item?.authorDetails?.firstName?.[0] ||
                                  item?.authorDetails?.ananomousName?.[0] ||
                                  "AD"
                                  }`.toUpperCase()}
                              </div>
                            </div>
                          </div>
                          <div className="person-info">
                            <p className="d-flex m-0">
                              {" "}
                              {item?.authorDetails?.name ||
                                item?.authorDetails?.ananomousName ||
                                (data.role == "admin" || data.role == "ADMIN"
                                  ? data?.firstName + " " + data?.lastName
                                  : "Admin ") ||
                                ""}{" "}
                              {item?.isDesabled && (
                                <div
                                  class=" p-0 p-1  rounded-lg color-danger"
                                  style={{
                                    fontSize: "10px",
                                    height: "10px",
                                    color: "red",
                                  }}
                                >
                                  Post Disabled
                                </div>
                              )}{" "}
                              {item?.authorDetails?.isBlockedFromCommunity && (
                                <div
                                  class=" p-0 p-1  rounded-lg color-danger"
                                  style={{
                                    fontSize: "10px",
                                    height: "10px",
                                    color: "red",
                                  }}
                                >
                                  {" "}
                                  User Block
                                </div>
                              )}
                              <pre className="mx-2">
                                {new Date(
                                  item?.created_at || item?.createdAt
                                ).toLocaleString("en-US", {
                                  hour12: true,
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </pre>
                              <div className="community-info-signs d-flex align-items-center text-right justify-right">
                                <Dropdown align="end" className="ms-1">
                                  <Dropdown.Toggle
                                    as="div"
                                    id="dropdown-custom-components"
                                    className="three-dots"
                                  >
                                    {(data._id == item?.authorDetails?._id ||
                                      data._id == item?.author ||
                                      data.role == "ADMIN") && (
                                        <BsThreeDotsVertical size={24} />
                                      )}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    {(data._id == item?.authorDetails?._id ||
                                      data._id == item?.author) && (
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleOptionClick(
                                              "post_delete",
                                              null,
                                              item
                                            )
                                          }
                                        >
                                          Post Delete
                                        </Dropdown.Item>
                                      )}

                                    {(data.role == "ADMIN" ||
                                      data.role == "admin") && (
                                        <>
                                          {" "}
                                          {item.isDesabled ? (
                                            <Dropdown.Item
                                              onClick={() =>
                                                handleOptionClick(
                                                  "post_enabled",
                                                  null,
                                                  item
                                                )
                                              }
                                            >
                                              Post Enabled
                                            </Dropdown.Item>
                                          ) : (
                                            <Dropdown.Item
                                              onClick={() =>
                                                handleOptionClick(
                                                  "post_disabled",
                                                  null,
                                                  item
                                                )
                                              }
                                            >
                                              Post Disabled
                                            </Dropdown.Item>
                                          )}
                                          {item?.authorDetails?.role ==
                                            "DOCTOR" ||
                                            item?.authorDetails?.role ==
                                            "PROVIDER" ? (
                                            item?.authorDetails
                                              ?.isBlockedFromCommunity ? (
                                              <Dropdown.Item
                                                onClick={() =>
                                                  handleOptionClick(
                                                    "user_enabled",
                                                    "Provider",
                                                    item
                                                  )
                                                }
                                              >
                                                User Enabled
                                              </Dropdown.Item>
                                            ) : (
                                              <Dropdown.Item
                                                onClick={() =>
                                                  handleOptionClick(
                                                    "user_disabled",
                                                    "Provider",
                                                    item
                                                  )
                                                }
                                              >
                                                User Disabled
                                              </Dropdown.Item>
                                            )
                                          ) : (
                                            item?.authorDetails &&
                                            (item?.authorDetails
                                              ?.isBlockedFromCommunity ? (
                                              <Dropdown.Item
                                                onClick={() =>
                                                  handleOptionClick(
                                                    "user_enabled",
                                                    "Patient",
                                                    item
                                                  )
                                                }
                                              >
                                                Patient Enabled
                                              </Dropdown.Item>
                                            ) : (
                                              <Dropdown.Item
                                                onClick={() =>
                                                  handleOptionClick(
                                                    "user_disabled",
                                                    "Patient",
                                                    item
                                                  )
                                                }
                                              >
                                                Patient Disable
                                              </Dropdown.Item>
                                            ))
                                          )}
                                        </>
                                      )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </p>
                            <div className="msg-emoji ">
                              <span>{item?.content}</span>
                              <div className="emoji d-flex gap-1 ">
                                <div
                                  onClick={() => addLike(item)}
                                  className={
                                    item.upvotes.includes(data._id)
                                      ? "reacted-emojis liked"
                                      : " reacted-emojis"
                                  }
                                  style={{
                                    color:
                                      item.upvotes.includes(data._id) &&
                                      "green",
                                    fontSize: "13px",
                                    fontWeight: "bolder",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FaRegThumbsUp />
                                  {item.upvotes.length}
                                </div>
                                {!data.isBlockedFromCommunity && (
                                  <div className="add-emoji">
                                    <LuMessageSquareReply
                                      onClick={() => handleReplyClick(item._id)}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Show Replies UI */}
                            {showReplies[item._id] && (
                              <div className="replies-section">
                                <div className="reply-input gap-2">
                                  <input
                                    type="text"
                                    value={replyText}
                                    onChange={(e) =>
                                      setReplyText(e.target.value)
                                    }
                                    placeholder="Add your reply..."
                                    className="form-control"
                                  />
                                  <Button
                                    className="filled-btn px-3"
                                    onClick={() =>
                                      handleAddReply(item, replyText)
                                    }
                                  >
                                    <IoSend />
                                  </Button>
                                </div>

                                <div
                                  className="replies-list mt-2 "
                                  ref={chatCommentsContainerRef}
                                  onScroll={() => handleCommentsScroll(item)}
                                >
                                  {replies[item._id]?.length > 0 ? (
                                    replies[item._id]?.map((reply, idx) => (
                                      <div key={idx} className="reply">
                                        <div className="reply-author">
                                          {reply?.commentAuthor?.name}{" "}
                                          {new Date(
                                            reply?.comments?.created_at
                                          ).toLocaleTimeString()}
                                        </div>
                                        <div className="reply-content">
                                          {reply?.comments?.content}
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="no-replies">
                                      No replies yet.
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <div className="community-empty-state text-center d-flex align-items-center justify-content-center">
                  <HiOutlineHashtag aria-hidden="true" />
                  <strong>No posts yet</strong>
                  <span>Start the conversation in this channel.</span>
                </div>
              )}
            </div>

            {!data.isBlockedFromCommunity && (
              <div className="text-box-block  d-flex justify-content-between align-items-center">
                <div className="left-textbox  ">
                  <div className="input-container">
                    {/* <span class="plus-icon">+</span>
                    <input type="file" class="file-input" /> */}
                    {/* <textarea
                      type="text"
                      value={messageText}
                      onChange={(e) => setMessageText(e.target.value)}
                      placeholder="Type something"
                      class="text-input"
                    /> */}

                    <textarea
                      ref={textareaRef}
                      value={messageText}
                      onChange={(e) => setMessageText(e.target.value)}
                      placeholder={`Message #${community.name}`}
                      className="text-input"
                      rows="1"
                      aria-label={`Message ${community.name}`}
                      style={{
                        overflow: "hidden",
                        resize: "none",
                      }}
                    />
                  </div>
                </div>
                <div className="right-textbox">
                  <Button
                    className="filled-btn"
                    onClick={uplodPost}
                    disabled={!messageText.trim()}
                  >
                    Send
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
export default CommunityComponent;
